import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Grid, Card } from '@material-ui/core';
import { useDispatch, useSelector } from "react-redux";
import TableGeneric from "../../compartidos/abms/TableGeneric";
import BuscadorAbm from "../../compartidos/abms/BuscadorAbm";
import ModalAbm from "../../compartidos/abms/ModalAbm";
import { agregarTipoDocumento, buscarDocumento, eliminarDocumento, modificarTipoDocumento, traerTipoDocumentaciones } from "../../../actions/abm/abm";
import { CATEGORIAS_TIPO_DOCUMENTACION } from "../../../utils/constants";
import { TIPO_DOCUMENTACION_PERMISOS } from "../../../utils/permisos";
import FormTipoDocumentacion from "./FormTipoDocumentacion";
import AccionesGenericoAbm from "../../compartidos/abms/AccionesGenericoAbm";

const useStyles = makeStyles({
  root: {
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "1rem"
  }
});

export const HomeTiposDeDocumentaciones = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const { items } = useSelector((state) => state.documentos);

  const [open, setOpen] = useState(false);
  const [openAlta, setOpenAlta] = useState(false);
  const [tipo, setTipo] = useState(false);

  const handleSearch = (textoBuscado) => {
    dispatch(buscarDocumento(textoBuscado));
  }

  const handleTipoSelect = (item) => {
    setTipo(item)
    setOpen(true)
  }

  const handleSave = (item) => {
    if (item.idTipoDocumentaciones) {
      dispatch(modificarTipoDocumento(item.idTipoDocumentaciones, item));
    } else {
      dispatch(agregarTipoDocumento(item));
    }
  }

  const handleDelete = (item) => {
    dispatch(eliminarDocumento(item.idTipoDocumentaciones));
  }

  useEffect(() => {
    dispatch(traerTipoDocumentaciones());
    // eslint-disable-next-line
  }, [dispatch]);

  return (
    <div>
      <Grid container justify="center">
        <ModalAbm title="Alta tipo de documentacion" open={openAlta} setOpen={setOpenAlta}>
          <FormTipoDocumentacion form={null} handleSave={handleSave} permisoAlta={TIPO_DOCUMENTACION_PERMISOS.ALTA} />
        </ModalAbm>
        <ModalAbm title="Modificar tipo de documentacion" open={open} setOpen={setOpen}>
          <FormTipoDocumentacion form={tipo} handleSave={handleSave} permisoEdit={TIPO_DOCUMENTACION_PERMISOS.MODIFICACION} />
        </ModalAbm>
        <Grid item xs={12}>
          <Button variant="contained" color="primary" onClick={() => setOpenAlta(true)} style={{ float: "right", marginTop: "1rem" }}>+ Agregar tipo de documentación</Button>
        </Grid>
        <Grid item xs={12} md={6} className={classes.root}>
          <BuscadorAbm title="Buscar tipos de documentación" handleSearch={handleSearch} />
        </Grid>
        <Grid item xs={12} md={9} style={{ marginTop: "2rem" }}>
          <Card>
          <TableGeneric
            data={items}
            columns={[
              {
                label:"",
                customBody:(item) => (
                  <AccionesGenericoAbm
                    item={item}
                    handleItemSelect={handleTipoSelect}
                    permisoDelete={TIPO_DOCUMENTACION_PERMISOS.BAJA}
                    handleDelete={handleDelete}
                  />
                )
              },
              {
                label: "ID",
                id: "idTipoDocumentaciones",
                sort: true
              },
              {
                label: "Nombre",
                id: "descripcionDocumentacion",
                sort: true
              },
              {
                label: "Categoría",
                id: "idCategoria",
                customBody: (item) => (
                  (item.idCategoria === CATEGORIAS_TIPO_DOCUMENTACION.DATOS_PERSONALES && "Datos Personales")
                  ||
                  (item.idCategoria === CATEGORIAS_TIPO_DOCUMENTACION.EMPRESA && "Empresa")
                ),
                sort: true
              }
            ]}
          />
          </Card>
        </Grid>
      </Grid>
    </div>
  );

};
